var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-2",attrs:{"icon":"","title":"Reset all the data","loading":_vm.isLoading},on:{"click":_vm.reset}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiLockReset))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }